import {
  Armchair,
  BedDouble,
  Candy,
  CookingPot,
  Cookie,
  Droplets,
  Footprints,
  Gem,
  Headphones,
  Laptop,
  ShoppingBasket,
  Smartphone,
  Shirt,
  Package,
} from 'lucide-react';

// Categories carry no icon/image yet, so each gets a glyph and a tint from
// its slug/name. Order matters: the first keyword that matches wins.
const ICON_RULES = [
  [/t-?shirt|shirt|cloth|men$|kurta|dress|saree|fashion|women/, Shirt, '#fde7ef', '#be185d'],
  [/foot|shoe|sneaker|jutti/, Footprints, '#fef3e2', '#b45309'],
  [/mobile|phone/, Smartphone, '#e8f2ff', '#0063c6'],
  [/headphone|earbud|audio/, Headphones, '#ede9fe', '#6b46c1'],
  [/laptop|computer/, Laptop, '#e8f2ff', '#0063c6'],
  [/electronic/, Smartphone, '#e8f2ff', '#0063c6'],
  [/cookware|kitchen|kadai/, CookingPot, '#fff1e6', '#c2410c'],
  [/bed|sheet/, BedDouble, '#ecfdf5', '#047857'],
  [/home|furniture/, Armchair, '#ecfdf5', '#047857'],
  [/sweet|mithai/, Candy, '#fdf2f8', '#be185d'],
  [/namkeen|snack/, Cookie, '#fef9c3', '#a16207'],
  [/grocery|gourmet|food/, ShoppingBasket, '#f0fdf4', '#15803d'],
  [/skin|serum|beauty|care/, Droplets, '#fdf4ff', '#a21caf'],
  [/jewel|gem/, Gem, '#fff7ed', '#c2410c'],
];

export const categoryLook = (cat) => {
  const key = `${cat?.slug || ''} ${cat?.name || ''}`.toLowerCase();
  const hit = ICON_RULES.find(([re]) => re.test(key));
  return hit ? { Icon: hit[1], bg: hit[2], fg: hit[3] } : { Icon: Package, bg: '#f2f4fb', fg: '#3a4049' };
};

